import React, { useEffect } from 'react'
import Menu from '../../../components/Menu'
import DropdownSearch from '../../../components/DropdownSearch'
import Modal from '../../../components/Modal';
import Loading from '../../../components/Loading';

import SEARCH from "../../../assets/vw/svg/search.svg";
import WARNING from "../../../assets/vw/svg/warning-icon.svg";
import download_icon from "../../../assets/vw/svg/download.svg";
import logs_icon from "../../../assets/vw/icons/logs-azul.svg";

const inputLogInitial = {
  nomLamb:"",
  filtro:""
}
function Logs({servicio}) {
  const backendUrl = process.env.REACT_APP_URL_DTO_BACK;
  const [inputLog, setInputLog] = React.useState(inputLogInitial);
  const [lambdas, setLambdas] = React.useState([]);
  const [logs, setLogs] = React.useState([]);
  const [mensaje, setMensaje] = React.useState("");
  const [urlDownload, setUrlDownload] = React.useState("");
  const [modal, setModal] = React.useState({
    active: false,
    message: "",
    success: false,
    tryAgain: false
  });
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    fetchLambdas();
  }, []);

  async function fetchLambdas () {
    setLoading(true);
    try {
      const response = await fetch(backendUrl + 'aplicacion/funciones',
        {
          method:'GET',
          headers: {
            Authorization: "Bearer " + servicio.getToken(),
            "Content-Type": "application/json",
          },
        }
      );
      
      if(response.status === 200) {
        const data = await response.json();
        const lambdas = data.mensaje.map((lambda) => ({
          nomLamb: lambda,
        }))
        setLambdas(lambdas);
      } else if(response.status === 504) {
        setModal({
          active: true,
          message: "Tiempo de espera agotado",
          success: false,
          tryAgain: true,
          tryAgainText: "Reintentar"
        });
      }

    } catch (error) {
      console.error('Error fetching lambdas:', error.stack || error);
      setModal({
        active: true,
        message: "Error al obtener las Lambdas. Por favor, inténtelo de nuevo más tarde.",
        success: false,
        tryAgain: true,
        tryAgainText: "Reintentar"
      });
      setLambdas([]);
    } finally {
      setLoading(false);
    }
  };

  function buildQueryParams () {
    const queryParams = [];
    const params = {...inputLog}
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const value = encodeURIComponent(params[key]);

        if (value !== "") {
          queryParams.push(`${key}=${value}`);
        }
      }
    }
    const queryParamsString = queryParams.join("&");
    return queryParamsString;
  }

  async function getLogs() {
    const queryParams = buildQueryParams();
    setMensaje("");
    setLogs([]);
    setUrlDownload("");
    setLoading(true);
    try {
      const response = await fetch(backendUrl + 'aplicacion/logs?' + queryParams,
        {
          method:'GET',
          headers: {
            Authorization: "Bearer " + servicio.getToken(),
            "Content-Type": "application/json",
          }
        }
      );  

      if(response.ok){
        if(response.status === 504){
          setLoading(false);
          setModal({
            active: true,
            message: "Tiempo de espera agotado",
            success: false,
            tryAgain: true
          });
          console.error("Error 504: Gateway Timeout - stack trace not available for HTTP errors");
          return;
        }
        const data = await response.json();

        if (response.status === 200) {
          if (typeof data.mensaje.logs === 'object') {
            setLogs(data.mensaje.logs);
            setUrlDownload(data.mensaje.archivoLogs);
          } else {
            setLogs([]);

            if (inputLog.filtro !== "" && inputLog.nomLamb !== "") {
              setMensaje("No se encontraron logs con los filtros seleccionados.");
            } else if(inputLog.filtro === "" && inputLog.nomLamb !== "") {
              setMensaje("No hay logs disponibles para la Lambda seleccionada.");
            }
          }
        }
      }
      
    } catch (error) {
      console.error('Error fetching logs:', error.stack || error);
      setModal({
        active: true,
        message: "Error al obtener los logs. Por favor, inténtelo de nuevo más tarde.",
        success: false,
        tryAgain: true,
        tryAgainText: "Reintentar"
      });
      setLogs([]);
    } finally {
      setLoading(false);
    }
  }

  const disabled_buscar = () => {
    return inputLog.nomLamb === "";
  }

  const printLogs = () => {
    if (logs.length > 0) {
      return logs.map((log, index) => (
        <div key={index} className="log-item p-0">
          <div className="log-timestamp">
            {new Date(log.timestamp).toLocaleString()}
          </div>
          <div className="divider-log">{' '}</div>
          <div className="log-text">
            <span className="text-log">
              {log.message}
            </span>
          </div>
        </div>
      ));
    } else {
      return (
        <div>
          { mensaje ? mensaje : "" }
        </div>
      );
    }
  };

  const handleDownload = () => {
    if (urlDownload) {
      try {
        // Crear un enlace temporal para forzar la descarga
        const link = document.createElement('a');
        link.href = urlDownload;
        link.target = '_blank'; // Abrir en una nueva pestaña
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Eliminar el enlace después de usarlo
      } catch (error) {
        console.error('Error al intentar descargar el archivo:', error.stack || error);
      }
    } else {
      console.error('URL de descarga no disponible - stack trace not available for this error');
    }
  };

  return (
    <>
      <Menu />
      <Modal modalInfo={modal} setMostrarModal={setModal} />
      {loading && <Loading />}
      <div className={`navegacion`}>
        <div className=" posicionMenu">
          <ul className="d-flex flex-row px-0 my-0">
            <li
              className="opcion-ruta normal_width"
            >
              <div
                className={`nav-link active ps-0 active border_menu`}
              >
                <img
                  src={logs_icon}
                  alt="accesos"
                  className="icono-menu me-3"
                />
                Logs
              </div>
            </li>
            
          </ul>
        </div>
        <div className="row border_vw pt-4">
          <div className='navegacion-logs'>
            <div className='container-logs'>
              <div className="">
                <h3 className="title-logs">
                  Buscar Logs
                </h3>
              </div>
              <div className='container-filter-logs'>
                <div className='filter-logs'>
                  <div className='d-flex align-items-center'>
                    <DropdownSearch
                      menu={lambdas}
                      title={"Lambdas"}
                      defaultValue={inputLog.nomLamb}
                      handleOptionSelected={(e) => {
                        setInputLog({
                          ...inputLog,
                          nomLamb: e.props.value,
                        });
                      }}
                      fieldID={'nomLamb'}
                      fieldToShow={'nomLamb'}
                      extraStyle="w-100"
                    />
                  </div>
                  <div className='input-logs'>
                    <div className='wrapper m-0 p-0'>
                      <input
                        className="input_vw"
                        name="searchInput"
                        value={inputLog.filtro || ""}
                        onChange={(e) => {
                          setInputLog({
                            ...inputLog,
                            filtro: e.target.value,
                          });
                        }}
                        placeholder="Busca palabra clave (sensible a mayúsculas)..."
                      />
                      <span className="pt-2 ps-1">
                        <img src={SEARCH} alt="buscar" className="icono-menu me-3"/>
                      </span>
                    </div>
                  </div>
                </div>
                <div className='container-button-logs'>
                  <button
                    type="button"
                    className="button_vw button_vw--primary h-100 m-0 "
                    onClick={()=>{
                      getLogs();
                    }}
                    disabled={disabled_buscar()}
                  >
                    Buscar
                  </button>
                </div>
              </div>
              <div>
                <div className='logs-title-container'>
                  <div className='aviso'>
                    <img src={WARNING} alt="aviso" className='icono-aviso'/>
                    <div className='aviso-text'>
                      {"Sólo se muestran los logs generados en los últimos 15 minutos a partir de la fecha actual. Si deseas conservar los logs, asegúrate de descargar el archivo generado."}
                    </div>
                  </div>
                  <span className='subtitle'>Visualización de Logs</span>
                </div>
              </div>
              <div className=''>
                <div className='logs-list'>
                  <div className='logs-text'>
                    {
                      printLogs()
                    }
                  </div>
                </div>
              </div>
              <div className='download-logs'>
                {
                  logs.length > 0 ? (
                    <button
                      type="submit"
                      className="button_vw button_vw--descarga w-auto d-flex align-items-center justify-content-center px-4"
                      onClick={handleDownload}
                    >
                      <img src={download_icon} alt="download" className="icono-download"/>
                      <span className={"ml-2"}>Descargar Log</span>
                    </button>
                  ) : ""
                }
              </div>
            </div>
          </div>
        </div>
      
    </div>
      
    </>
  )
}

export default Logs